import { useTranslation } from "react-i18next";
import { BaseInsight, InsightsParams } from "./Insight.types";
import { filter } from "lodash";
import { DimensionWithScores } from "@/features/people";
import {
  getTopValuesInsight,
  getBottomValuesInsight,
} from "./getValuesInsight";

export interface ValuesInsight extends BaseInsight {
  type: "important_values" | "least_important_values";
}

export const useValuesInsights = (params: InsightsParams) => {
  const { dimensions, defaultPersonId } = params;
  const { t } = useTranslation();

  const childDimensions = filter(dimensions, (dim) => dim.parentId !== null);

  const getTopValues = (): ValuesInsight[] => {
    return childDimensions
      .map((dim) => getTopValuesInsight(dim, { ...params, defaultPersonId }, t))
      .filter((insight): insight is ValuesInsight => insight !== null);
  };

  const getBottomValues = (): ValuesInsight[] => {
    return childDimensions
      .map((dim) =>
        getBottomValuesInsight(dim, { ...params, defaultPersonId }, t)
      )
      .filter((insight): insight is ValuesInsight => insight !== null);
  };

  return {
    topValues: getTopValues(),
    bottomValues: getBottomValues(),
  };
};
